module.exports = __webpack_public_path__ + "static/img/loader-zig.93b11f9.gif";